// ============================================================
//  BIRTHDAY WEBSITE CONFIGURATION
//  Edit the values below to customize the experience.
//  No code knowledge needed - just change the text and URLs.
// ============================================================

const CONFIG = {

  // --- RECIPIENT ---
  recipientName: 'Joudie',
  recipientCodename: 'Agent Joudie',

  // --- SENDER ---
  senderName: 'Royal',

  // --- BROWSER TAB & EMBED ---
  // The text shown in the browser tab and the favicon emoji
  tabTitle: '// CLASSIFIED INFO // ',
  tabIcon: '/umbrella-corporation-logo.png',
  // Social embed (Discord, iMessage, etc.)
  siteDescription: 'ACCESS RESTRICTED — Umbrella Corporation Classified Personnel File',

  // --- PASSWORD ---
  // The 6-digit code to enter the site
  passwordCode: '088343',

  // --- BIRTHDAY DATE ---
  // Format: YYYY-MM-DD (used for countdown timer)
  birthdayDate: '2026-03-22',

  // --- SAFE PUZZLE CODE ---
  // The 8-digit safe code (her birthday: DDMMYYYY)
  safeCode: [2, 2, 0, 3, 2, 0, 0, 6],

  // --- BIRTHDAY MESSAGE ---
  // The personal letter shown after all gifts are revealed
  birthdayMessage: {
    greeting: 'Dear Joudie,',
    paragraphs: [
      "If you're reading this, it means you've completed every challenge I set up for you. But the truth is, the real challenge was trying to create something worthy of how incredible you are.",
      "Every puzzle was a piece of how I see you: brilliant, determined, and full of surprises. Every clue led to you because you're the answer to everything good in my life.",
      "I wish I could give you the whole world. For now, I hope this little corner of the internet makes you smile. Happy Birthday, my love.",
    ],
    signOff: 'Forever yours,',
  },

  // --- LEON'S FINAL MESSAGE ---
  leonFinalMessage:
    '"Agent Joudie, this is my final transmission. You\'ve proven yourself as one of the most capable operatives I\'ve ever had the honor of guiding. But between you and me? Royal is one lucky person. Take care of yourself out there. Happy Birthday. -- Leon"',

  // --- GIFTS ---
  // Tap-to-reveal gift cards. Set `link` to a URL to make them clickable.
  gifts: [
    {
      id: 'steam',
      label: 'Classified Reward #1',
      title: 'Steam Gift Card',
      description: "For all the games we'll play together",
      link: '', // e.g. 'https://store.steampowered.com/...'
      iconName: 'Gamepad2',
      colorFrom: 'from-blue-900',
      colorTo: 'to-blue-950',
      borderColor: 'border-blue-500',
      iconColor: 'text-blue-400',
      glowColor: 'shadow-blue-500/30',
    },
    {
      id: 'nitro',
      label: 'Classified Reward #2',
      title: 'Discord Nitro',
      description: 'Because you deserve all the emotes',
      link: '',
      iconName: 'Sparkles',
      colorFrom: 'from-indigo-900',
      colorTo: 'to-indigo-950',
      borderColor: 'border-indigo-500',
      iconColor: 'text-indigo-400',
      glowColor: 'shadow-indigo-500/30',
    },
    {
      id: 'spotify',
      label: 'Classified Reward #3',
      title: 'Spotify Playlist',
      description: 'A playlist made just for you',
      link: '', // e.g. 'https://open.spotify.com/playlist/...'
      iconName: 'Music',
      colorFrom: 'from-green-900',
      colorTo: 'to-green-950',
      borderColor: 'border-green-500',
      iconColor: 'text-green-400',
      glowColor: 'shadow-green-500/30',
    },
    {
      id: 'lilies',
      label: 'Special Reward',
      title: 'Lilies For You',
      description:
        "I couldn't bring you real ones... so here they are, forever blooming in this little corner of the internet, just for you.",
      link: '',
      iconName: 'Flower2',
      colorFrom: 'from-pink-900',
      colorTo: 'to-pink-950',
      borderColor: 'border-pink-500',
      iconColor: 'text-pink-400',
      glowColor: 'shadow-pink-500/30',
      isSpecial: true,
    },
  ],

  // --- PHOTOS ---
  // Replace placeholder URLs with real photo URLs.
  // Add or remove entries as needed.
  photos: [
    { id: 1, url: '', caption: '' },
    { id: 2, url: '', caption: '' },
    { id: 3, url: '', caption: '' },
    { id: 4, url: '', caption: '' },
    { id: 5, url: '', caption: '' },
    { id: 6, url: '', caption: '' },
  ],

  // --- SPECIAL IMAGE ---
  // Image shown in the "Lilies" gift card
  lilyImageUrl:
    'https://images.unsplash.com/photo-1603407474196-ab69cfd0410e?w=600&q=80',
};

export default CONFIG;
